import { render, staticRenderFns } from "./TicketMainSectionLeftColumn.vue?vue&type=template&id=27b1696c&scoped=true&"
import script from "./TicketMainSectionLeftColumn.vue?vue&type=script&lang=js&"
export * from "./TicketMainSectionLeftColumn.vue?vue&type=script&lang=js&"
import style0 from "./TicketMainSectionLeftColumn.vue?vue&type=style&index=0&id=27b1696c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1696c",
  null
  
)

export default component.exports